var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5 text-white refresh-button-container"},[_c('a',{on:{"click":_vm.refresh}},[_c('div',[_vm._v(_vm._s(_vm.$t('general.refresh')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }